import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { toast } from "sonner";

export default function AdminWaiter() {
  const [reqs, setReqs] = useState([]);
  const load = () => api.get("/admin/waiter").then((r) => setReqs(r.data));
  useEffect(() => { load(); const iv = setInterval(load, 4000); return () => clearInterval(iv); }, []);

  const complete = async (id) => { await api.patch(`/admin/waiter/${id}/complete`); toast.success("Marked completed"); load(); };

  const pending = reqs.filter((r) => r.status === "pending");
  const done = reqs.filter((r) => r.status === "completed");

  return (
    <div>
      <header className="mb-6">
        <div className="text-xs uppercase tracking-widest text-gray-400">Realtime</div>
        <h1 className="font-display text-2xl font-bold tracking-tight mt-1">Waiter Requests</h1>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-gray-500 mb-3">Pending · {pending.length}</div>
          <div className="space-y-2">
            {pending.map((r) => (
              <div key={r.id} data-testid={`waiter-req-${r.id}`} className="qd-admin-card p-4 flex items-center justify-between border-l-4 border-l-[var(--qd-primary)]">
                <div>
                  <div className="flex items-center gap-2"><Bell className="w-4 h-4 text-[var(--qd-primary)]" /><span className="font-semibold capitalize">{r.type}</span></div>
                  <div className="text-xs text-gray-500 mt-1">{r.table_label} · {new Date(r.created_at).toLocaleTimeString()}</div>
                </div>
                <button data-testid={`waiter-complete-${r.id}`} onClick={() => complete(r.id)} className="text-xs font-semibold px-3 py-1.5 rounded-md bg-[var(--qd-charcoal)] text-white hover:bg-black">Complete</button>
              </div>
            ))}
            {pending.length === 0 && <div className="text-sm text-gray-400 p-4 text-center">All caught up ✨</div>}
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-gray-500 mb-3">Completed · {done.length}</div>
          <div className="space-y-2">
            {done.slice(0, 20).map((r) => (
              <div key={r.id} className="qd-admin-card p-3 flex items-center justify-between opacity-70">
                <div className="text-sm capitalize">{r.type} · {r.table_label}</div>
                <div className="text-xs text-gray-400">{new Date(r.created_at).toLocaleTimeString()}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
